import { API_BASE_URL } from "../config/api";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { clearAuthSession } from "../utils/auth";

function AdminLogin() {
  const [loginId, setLoginId] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMessage("");
    setIsSubmitting(true);

    try {
      const res = await axios.post(API_BASE_URL + "/api/auth/login", {
        email: loginId,
        password
      });

      if (res.data.role !== "admin") {
        setErrorMessage("This account does not have admin access.");
        setIsSubmitting(false);
        return;
      }

      clearAuthSession();
      localStorage.setItem("token", res.data.token);
      localStorage.setItem("role", "admin");
      localStorage.setItem("adminName", res.data.name);
      localStorage.setItem("adminSession", "active");

      window.location.href = "/dashboard";
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Login failed");
      setIsSubmitting(false);
    }
  };

  return (
    <div className="theme-login-shell relative flex min-h-screen items-center justify-center overflow-hidden bg-[linear-gradient(135deg,_#020617,_#0f172a_55%,_#082f49)] px-4">
      <div className="absolute left-[-6rem] top-10 h-72 w-72 rounded-full bg-sky-500/20 blur-3xl" />
      <div className="absolute bottom-0 right-[-5rem] h-80 w-80 rounded-full bg-cyan-400/20 blur-3xl" />

      <form
        onSubmit={handleLogin}
        className="theme-login-card relative w-full max-w-md rounded-[2rem] border border-white/15 bg-white/95 p-8 shadow-2xl backdrop-blur"
      >
        <p className="text-center text-xs font-semibold uppercase tracking-[0.4em] text-sky-700">
          Genmech Service
        </p>
        <h1 className="mt-4 text-center text-3xl font-black text-slate-950">
          Admin Workspace Login
        </h1>
        <p className="mt-3 text-center text-sm leading-6 text-slate-600">
          Sign in to manage complaints, engineers, reports, and customer operations.
        </p>

        <div className="mt-8 space-y-5">
          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">Email ID</label>
            <input
              type="email"
              placeholder="Enter your email id"
              className="w-full rounded-2xl border border-sky-100 px-4 py-3 outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-100"
              value={loginId}
              onChange={(e) => setLoginId(e.target.value)}
              required
            />
          </div>

          <div>
            <label className="mb-2 block text-sm font-semibold text-slate-700">Password</label>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Enter your password"
              className="w-full rounded-2xl border border-sky-100 px-4 py-3 outline-none transition focus:border-sky-500 focus:ring-4 focus:ring-sky-100"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword((current) => !current)}
              className="mt-2 text-sm font-medium text-sky-700 transition hover:text-sky-900"
            >
              {showPassword ? "Hide Password" : "Show Password"}
            </button>
          </div>

          {errorMessage ? (
            <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
              {errorMessage}
            </div>
          ) : null}
        </div>

        <button
          type="submit"
          disabled={isSubmitting}
          className="mt-8 w-full rounded-2xl bg-sky-600 px-4 py-3 font-semibold text-white transition hover:bg-sky-500 disabled:cursor-not-allowed disabled:bg-sky-300"
        >
          {isSubmitting ? "Signing In..." : "Login"}
        </button>

        <div className="mt-6 text-center text-sm">
          <Link to="/" className="font-semibold text-sky-700 transition hover:text-sky-900">
            Back to role select
          </Link>
        </div>
      </form>
    </div>
  );
}

export default AdminLogin;


